import { useMutation, useQueryClient } from "@tanstack/react-query";
import { attemptDeleteOrgUser } from '../../api/OrgApi';
import { useToast } from '../../context/ToastContext';

export const useDeleteOrgUser = () => {
  const queryClient = useQueryClient();
  const { setToastMessage } = useToast();
  
  return useMutation({
    mutationKey: 'delete-org-user',
    mutationFn: ({ owner_id, data }) => attemptDeleteOrgUser(owner_id, data),
    onMutate: async (data) => {
      // Optional: Implement optimistic update logic here
    },
    onSuccess: () => {
      setToastMessage("User Deleted")
      queryClient.invalidateQueries({
        queryKey: ["org-users"],
      });
    },
    onError: (error) => {
      setToastMessage("Delete Failed")
    }
  });
};